import { createApp } from 'vue'
import LeadWidget from './LeadWidget.vue'
import dataAttributesToProps from '@/pages/dataAttributesToProps'
import gettext from "@/pages/translations";

const node = document.getElementById('leadwidget');
const props = dataAttributesToProps(node);
createApp(LeadWidget, props)
    .use(gettext(props.locale))
    .mount(node);
